import React, { useState, useEffect, useCallback, memo } from "react";
import * as yup from "yup";
import { API_URL } from "../../../constants";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../src/services/serviceCaller";
import moment from "moment";
import "./Employee_Profile.css";
import Select from "react-select";
import CustomDatePicker from "../../../../src/components/Custom-Datepicker";
import { toast } from "react-toastify";
import { FaStar, FaSpinner } from "react-icons/fa";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import KnowledgeBaseComponent from "./Component/KnowledgeBaseComponent";
import OfficialInformationComponent from "./Component/OfficialInformationComponent";
import AdditionalInfoComponent from "./Component/AdditionalInfoComponent";
import ProjectComponent from "./Component/ProjectComponent";
import ProfileEmpCard from "./Component/ProfileEmpCard";
import EmpBankAddressComponent from "./Component/EmpBankAddressComponent";
import PreviousEmpComponent from "./Component/PreviousEmpComponent";
import EmpAcademicTableComponent from "./Component/EmpAcademicTableComponent";
import EmpSkillTableComponent from "./Component/EmpSkillTableComponent";
import EmpCertificationTable from "./Component/EmpCertificationTable";
import EmpDomainComponent from "./Component/EmpDomainComponent";

const EmployeeProfile = () => {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  const DefaultContactID = user?.DefaultContactID;
  const shouldRenderComponent =
    id && DefaultContactID && id.toString() === DefaultContactID.toString();
  const defaultActiveTab = shouldRenderComponent ? "official" : "emp";

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Employee Profile"));
  }, []);
  const [empData, setEmpData] = useState("");
  const [employeeCanEdit, setEmployeeCanEdit] = useState("");
  const [currentProjectsData, setCurrentProjectsData] = useState([]);
  const [previousProjectsData, setPreviousProjectsData] = useState([]);
  const [employeeHistoryData, setEmployeeHistoryData] = useState([]);
  const [employeeAcademicData, setEmployeeAcademicData] = useState([]);
  const [employeeSkillData, setEmployeeSkillData] = useState([]);
  const [employeeCertificationData, setEmployeeCertificationData] = useState(
    []
  );
  const [empAwards, setEmpAwards] = useState([]);
  const [employeeDomainData, setEmployeeDomainData] = useState([]);
  const [AdditionalOpen, setAdditionalOpen] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const [officialOpen, setOfficialOpen] = useState(true);
  const [knowledgeBaseOpen, setKnowledgeBaseOpen] = useState(true);
  const [empHistoryModel, setEmpHistoryModel] = useState(false);
  const [empAcedemicModel, setEmpAcedemicModel] = useState(false);
  const [empTrainingModel, SetEmpTrainingModel] = useState(false);
  const [empDomainModel, setEmpDomainModel] = useState(false);
  const [empskillModel, setEmpSkillModel] = useState(false);
  const [skillsOptList, setSkillsOptList] = useState([]);
  const [subSkillOptList, setSubSkillOptList] = useState([]);
  const [experienceOptList, setExperienceOptList] = useState([]);
  const [knowledgeForum, setKnowledgeForum] = useState([]);
  const [additinalInfoData, setAdditinalInfoData] = useState([]);
  const [otherInfoData, setOtherInfoData] = useState([]);
  const [empadditionalInfoModel, setEmpAdditionalInfoModel] = useState(false);
  const [empOtheradditionalInfoModel, setEmpOtheradditionalInfoModel] =
    useState(false);
  const [formHistoryErrors, setFormHistoryErrors] = useState({});
  const [acedemicErrors, setAcedemicErrors] = useState({});
  const [trainingErrors, setTrainingErrors] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [skillErrors, setSkillErrors] = useState([]);
  const [EmpProfileImage, setEmpProfileImage] = useState("");
  const [index, setIndex] = useState(0);
  const [groupedAwards, setGroupedAwards] = useState([]);

  const [formData, setFormData] = useState({
    ID: "",
    LineNo: 1,
    CompanyName: "",
    Position: "",
    Location: "",
    FromDate: "",
    ToDate: "",
    OrganizationAddress: "",
    JobDescription: "",
  });

  const [acedemicFormData, setAcedemicFormData] = useState({
    LineNo: "",
    University: "",
    Institute: "",
    FromDate: "",
    ToDate: "",
    Degree_152: "",
    DegreeInfo: "",
    Description: "",
    Grade: "",
    TYPE: "",
  });

  const [trainingFormData, setTrainingFormData] = useState({
    LineNo: 1,
    Title: "",
    Description: "",
    ValidFrom: "",
    ValidTill: "",
  });

  const [domainFormData, setDomainFormData] = useState({
    ID: "",
    LineNo: 1,
    DomainID: "",
    Description: "",
    Experience: "",
    ClientName: "",
  });

  const [SkillformData, setSkillFormData] = useState({
    ID: "",
    LineNo: "",
    SkillID: "",
    SubSkillID: "",
    Description: "",
    Ratings: "",
    Experience: "",
    SkillType: "",
  });

  const [AddformData, setAddFormData] = useState({
    ID: "",
    PFNo: "",
    PANNo: "",
    AadhaarCardNo: "",
    LicenseNo: "",
    PassportNo: "",
    PassportEffectiveDate: "",
    PassportExpiryDate: "",
  });

  const [otherformData, setOtherFormData] = useState({
    ID: "",
    Name: "",
    MobileNo1: "",
  });

  const [degreeOptList, setDegreeOptList] = useState([]);
  const [domainOptList, setDomainOptList] = useState([]);
  const [skillSubmitting, setSkillSubmitting] = useState(false);

  const awardsliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const historySchema = yup.object().shape({
    CompanyName: yup.string().required("Company Name is required"),
    FromDate: yup.string().required("From Date is required"),
    ToDate: yup.string().required("To Date is required"),
  });

  const acedemicSchema = yup.object().shape({
    University: yup.string().required("University is required"),
    Institute: yup.string().required("Institute is required"),
    Degree_152: yup.string().required("Degree is required"),
    FromDate: yup.string().required("From Date is required"),
    ToDate: yup.string().required("To Date is required"),
  });

  const trainingSchema = yup.object().shape({
    Title: yup.string().required("Title is required"),
  });

  const domainSchema = yup.object().shape({
    DomainID: yup.string().required("Domain is required"),
  });

  const skillSchema = yup.object().shape({
    SkillID: yup.string().required("Skill is required"),
    SkillType: yup.string().required("Skill Type is required"),
  });

  const fetchEmployeeDetails = useCallback(async (id) => {
    setPageLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/users/profile/${id}`
      );
      if (response?.status === 200) {
        setEmployeeCanEdit(response?.data?.canEdit || "");
        setEmpData(response?.data?.profile?.[0] || {});
        setEmpAwards(response?.data?.awards || {});
        setCurrentProjectsData(response?.data?.currentProjects || {});
        setPreviousProjectsData(response?.data?.previousProjects || {});
        setEmployeeHistoryData(response?.data?.employmentHistory || {});
        setEmployeeAcademicData(response?.data?.academicDetails || {});
        setEmployeeSkillData(response?.data?.employeeSkills || {});
        setEmployeeCertificationData(
          response?.data?.employeeCertifications || {}
        );
        setEmployeeDomainData(response?.data?.employeeDomains || {});
        setKnowledgeForum(response?.data?.knowledgeBase || {});
        setAdditinalInfoData(response?.data?.additionalInfo || {});
        setOtherInfoData(response?.data?.otherOfficalInfo || "");
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Employee Details:", error);
      setPageLoading(false);
    }
  }, []);

  const fetchDegreeList = useCallback(async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}nest/users/profile`);
      setDegreeOptList(
        response?.data?.data?.degree?.map((item) => ({
          label: item.text,
          value: item.value,
        })) || []
      );
      setDomainOptList(
        response?.data?.data?.domain?.map((item) => ({
          label: item.text,
          value: item.value,
        })) || []
      );
      setSkillsOptList(
        response?.data?.data?.skills?.map((item) => ({
          label: item.text,
          value: item.value,
        })) || []
      );
      setExperienceOptList(
        Object.entries(response?.data?.data?.experience || {}).map(
          ([key, value]) => ({
            label: key,
            value: value,
          })
        ) || []
      );
    } catch (error) {
      console.error("Error fetching Employee Details:", error);
    }
  }, []);

  const callAnotherApi = useCallback(async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/users/profile/skillSets/getSubSkillSets?SkillID=${id}`
      );
      setSubSkillOptList(
        Object.entries(response?.data?.subSkills || {}).map(([key, value]) => ({
          label: value,
          value: key,
        })) || []
      );
    } catch (error) {
      console.error("API error:", error);
    }
  }, []);

  const resetHistoryForm = useCallback(() => {
    setFormData({
      ID: "",
      LineNo: 1,
      CompanyName: "",
      Position: "",
      Location: "",
      FromDate: "",
      ToDate: "",
      OrganizationAddress: "",
      JobDescription: "",
    });
    setFormHistoryErrors({});
  }, []);

  const resetAcedemicForm = useCallback(() => {
    setAcedemicFormData({
      LineNo: "",
      University: "",
      Institute: "",
      FromDate: "",
      ToDate: "",
      Degree_152: "",
      DegreeInfo: "",
      Description: "",
      Grade: "",
      TYPE: "",
    });
    setAcedemicErrors({});
  }, []);

  const resetEmpTrainingForm = useCallback(() => {
    setTrainingFormData({
      LineNo: "",
      Title: "",
      Description: "",
      ValidFrom: "",
      ValidTill: "",
    });
    setTrainingErrors({});
  }, []);

  const resetDomainForm = useCallback(() => {
    setDomainFormData({
      ID: "",
      LineNo: 1,
      DomainID: "",
      Description: "",
      Experience: "",
      ClientName: "",
    });
    setFormErrors({});
  }, []);

  const resetSkillForm = useCallback(() => {
    setSkillFormData({
      ID: "",
      LineNo: "",
      SkillID: "",
      SubSkillID: "",
      Description: "",
      Ratings: "",
      Experience: "",
      SkillType: "",
    });
    setSkillErrors({});
  }, []);

  const handleEmpHistoryAdd = useCallback(() => {
    resetHistoryForm();
    setEmpHistoryModel(true);
  }, [resetHistoryForm]);

  const handleEmpHistoryEdit = useCallback((historyItem) => {
    setFormData({
      ID: historyItem.ID || "",
      LineNo: historyItem.LineNo || "",
      CompanyName: historyItem.CompanyName || "",
      Position: historyItem.Position || "",
      Location: historyItem.Location || "",
      JobDescription: historyItem.JobDescription || "",
      FromDate: historyItem.FromDate
        ? moment(historyItem.FromDate).format("DD-MMM-YYYY")
        : "",
      ToDate: historyItem.ToDate
        ? moment(historyItem.ToDate).format("DD-MMM-YYYY")
        : "",
      OrganizationAddress: historyItem.OrganizationAddress || "",
    });
    setEmpHistoryModel(true);
  }, []);

  const handleEmpHistoryDelete = useCallback(
    async (delItem) => {
      try {
        const response = await DeleteServiceCaller(
          `${API_URL}nest/users/profile/employementDatails/${delItem.ID}/${delItem.LineNo}`,
          "delete"
        );

        if (response.ok) {
          toast.success("Employment history deleted successfully!");
          fetchEmployeeDetails(id);
        } else {
          toast.error("Failed to delete employment history. Please try again.");
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
      }
    },
    [id, fetchEmployeeDetails]
  );

  const handleEmpHistoryChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      setFormHistoryErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else {
      const { name, value } = e;
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      setFormHistoryErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  }, []);

  const handleEmpHistorySubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        await historySchema.validate(formData, { abortEarly: false });
        setFormHistoryErrors({});

        const url = formData.ID
          ? `${API_URL}nest/users/profile/employementDatails/${formData.ID}`
          : `${API_URL}nest/users/profile/employementDatails`;

        const method = formData.ID ? "put" : "post";

        const response = await PostFormServiceCaller(url, formData, method);

        if (response.status === 200 || response.status === 201) {
          toast.success(
            `Employment History details ${
              formData.ID ? "updated" : "submitted"
            } successfully!`
          );
          setEmpHistoryModel(false);
          fetchEmployeeDetails(id);
        }
      } catch (err) {
        if (err.name === "ValidationError") {
          const errors = {};
          err.inner.forEach((error) => {
            errors[error.path] = error.message;
          });
          setFormHistoryErrors(errors);
        } else {
          console.error("Error:", err);
          toast.error("Failed to submit. Please try again.");
        }
      }
    },
    [formData, id, fetchEmployeeDetails]
  );

  const handleEmpAcademicAdd = useCallback(() => {
    resetAcedemicForm();
    setEmpAcedemicModel(true);
  }, [resetAcedemicForm]);

  const handleEmpAcademicEdit = useCallback((Item) => {
    setAcedemicFormData({
      ID: Item.ID || "",
      LineNo: Item.LineNo || "",
      University: Item.University || "",
      Institute: Item.Institute || "",
      FromDate: Item.FromDate || "",
      ToDate: Item.ToDate || "",
      Degree_152: Item.Degree_152 || "",
      DegreeInfo: Item.DegreeInfo || "",
      Description: Item.Description || "",
      Grade: Item.Grade || "",
    });
    setEmpAcedemicModel(true);
  }, []);

  const handleEmpAcademicChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
         if (
      (name === "Description" || name === "DegreeInfo") &&
      value.length > 255
    ) {
      setAcedemicErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 255 characters allowed for ${name}.`,
      }));
      return; 
    }
      setAcedemicFormData((prevData) => ({ ...prevData, [name]: value }));
      setAcedemicErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else {
      const { name, value } = e;
        if (
      (name === "Description" || name === "DegreeInfo") &&
      value.length > 255
    ) {
      setAcedemicErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 255 characters allowed for ${name}.`,
      }));
      return;
    }
      setAcedemicFormData((prevData) => ({ ...prevData, [name]: value }));
      setAcedemicErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  }, []);

  const handleEmpAcademicSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const maxLineNo =
          employeeAcademicData.length > 0
            ? Math.max(...employeeAcademicData.map((item) => item.LineNo))
            : 0;
        const nextLineNo = maxLineNo + 1;

        const formDataToSubmit = acedemicFormData.ID
          ? acedemicFormData
          : { ...acedemicFormData, LineNo: nextLineNo };

        await acedemicSchema.validate(formDataToSubmit, { abortEarly: false });
        setAcedemicErrors({});

        const formattedData = {
          ...formDataToSubmit,
          FromDate: formDataToSubmit.FromDate
            ? moment(formDataToSubmit.FromDate).format("YYYY-MM-DD")
            : "",
          ToDate: formDataToSubmit.ToDate
            ? moment(formDataToSubmit.ToDate).format("YYYY-MM-DD")
            : "",
        };

        const url = formDataToSubmit.ID
          ? `${API_URL}nest/users/profile/empAcademicDetails/${formDataToSubmit.ID}`
          : `${API_URL}nest/users/profile/empAcademicDetails`;

        const method = formDataToSubmit.ID ? "put" : "post";

        const response = await PostFormServiceCaller(
          url,
          formattedData,
          method
        );

        if (response.status === 200 || response.status === 201) {
          toast.success(
            `Academic details ${
              formDataToSubmit.ID ? "updated" : "submitted"
            } successfully!`
          );
          setEmpAcedemicModel(false);
          fetchEmployeeDetails(id);
        }
      } catch (error) {
        if (error.name === "ValidationError") {
          const newErrors = {};
          error.inner.forEach((err) => {
            newErrors[err.path] = err.message;
          });
          setAcedemicErrors(newErrors);
        } else {
          console.error("Submission error:", error);
          toast.error("Failed to submit form. Please try again.");
        }
      }
    },
    [acedemicFormData, employeeAcademicData, id, fetchEmployeeDetails]
  );

  const handleEmpTraining = useCallback(() => {
    resetEmpTrainingForm();
    SetEmpTrainingModel(true);
  }, [resetEmpTrainingForm]);

  const handleEmpTrainingEdit = useCallback((traItem) => {
    setTrainingFormData({
      ID: traItem.ID || "",
      Title: traItem.Title || "",
      LineNo: traItem.LineNo || "",
      Description: traItem.Description || "",
      Position: traItem.Position || "",
      ValidFrom: traItem.ValidFrom
        ? moment(traItem.ValidFrom).format("DD-MMM-YYYY")
        : "",
      ValidTill: traItem.ValidTill
        ? moment(traItem.ValidTill).format("DD-MMM-YYYY")
        : "",
    });
    SetEmpTrainingModel(true);
  }, []);

  const handleEmpTrainingChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
       if (
      (name === "Description") &&
      value.length > 500
    ) {
      setTrainingErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 500 Characters allowed for ${name}.`,
      }));
      return;
    }
      setTrainingFormData((prevData) => ({ ...prevData, [name]: value }));
      setTrainingErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else {
      const { name, value } = e;
        if (
      (name === "Description") &&
      value.length > 500
    ) {
      setTrainingErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 500 Characters allowed for ${name}.`,
      }));
      return;
    }
      setTrainingFormData((prevData) => ({ ...prevData, [name]: value }));
      setTrainingErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  }, []);

  const handleEmpTrainingSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const maxLineNo =
          employeeCertificationData.length > 0
            ? Math.max(...employeeCertificationData.map((item) => item.LineNo))
            : 0;
        const nextLineNo = maxLineNo + 1;

        const formDataToSubmit = trainingFormData.ID
          ? trainingFormData
          : { ...trainingFormData, LineNo: nextLineNo };

        await trainingSchema.validate(formDataToSubmit, { abortEarly: false });
        setTrainingErrors({});

        const TrainingData = {
          ...formDataToSubmit,
          ValidFrom: formDataToSubmit.ValidFrom
            ? moment(formDataToSubmit.ValidFrom).format("YYYY-MM-DD")
            : "",
          ValidTill: formDataToSubmit.ValidTill
            ? moment(formDataToSubmit.ValidTill).format("YYYY-MM-DD")
            : "",
        };

        const url = formDataToSubmit.ID
          ? `${API_URL}nest/users/profile/empCertification&Training/${formDataToSubmit.ID}`
          : `${API_URL}nest/users/profile/empCertification&Training`;

        const method = formDataToSubmit.ID ? "put" : "post";

        const response = await PostFormServiceCaller(url, TrainingData, method);

        if (response.status === 200 || response.status === 201) {
          toast.success(
            `Employment Certification details ${
              formDataToSubmit.ID ? "updated" : "submitted"
            } successfully!`
          );
          SetEmpTrainingModel(false);
          fetchEmployeeDetails(id);
        }
      } catch (error) {
        if (error.name === "ValidationError") {
          const errors = {};
          error.inner.forEach((err) => {
            errors[err.path] = err.message;
          });
          setTrainingErrors(errors);
        } else {
          console.error("Validation or API error:", error);
          toast.error("Something went wrong. Please try again.");
        }
      }
    },
    [trainingFormData, employeeCertificationData, id, fetchEmployeeDetails]
  );

  const handleEmpDomainAdd = useCallback(() => {
    resetDomainForm();
    setEmpDomainModel(true);
  }, [resetDomainForm]);

  const handleEmpDomainEdit = useCallback(
    (itemDomain) => {
      const matchedOption = domainOptList.find(
        (opt) => opt.label === itemDomain.Domain
      );
      setDomainFormData({
        ID: itemDomain.ContactID || "",
        LineNo: itemDomain.LineNo || "",
        DomainID: matchedOption?.value || "",
        Domain: itemDomain.Domain || "",
        Description: itemDomain.DomainDetails || "",
        Experience: itemDomain.Experience || "",
        ClientName: itemDomain.ClientName || "",
      });
      setEmpDomainModel(true);
    },
    [domainOptList]
  );

  const handleEmpDomainChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
       if (
      (name === "Description") &&
      value.length > 500
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 500 Characters allowed for ${name}.`,
      }));
      return;
    }
      setDomainFormData((prevData) => ({ ...prevData, [name]: value }));
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else {
      const { name, value } = e;
             if (
      (name === "Description") &&
      value.length > 500
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 500 Characters allowed for ${name}.`,
      }));
      return;
    }
      setDomainFormData((prevData) => ({ ...prevData, [name]: value }));
      setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  }, []);

  const handleEmpDomainSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const maxLineNo =
          employeeDomainData.length > 0
            ? Math.max(...employeeDomainData.map((item) => item.LineNo))
            : 0;
        const nextLineNo = maxLineNo + 1;

        const formDataToSubmit = domainFormData.ID
          ? domainFormData
          : { ...domainFormData, LineNo: nextLineNo };

        await domainSchema.validate(formDataToSubmit, { abortEarly: false });
        setFormErrors({});

        const url = formDataToSubmit.ID
          ? `${API_URL}nest/users/profile/empDomain/${formDataToSubmit.ID}`
          : `${API_URL}nest/users/profile/empDomain`;

        const method = formDataToSubmit.ID ? "put" : "post";

        const response = await PostFormServiceCaller(
          url,
          formDataToSubmit,
          method
        );

        if (response.status === 200 || response.status === 201) {
          toast.success(
            `Employment Domain details ${
              formDataToSubmit.ID ? "updated" : "submitted"
            } successfully!`
          );
          setEmpDomainModel(false);
          fetchEmployeeDetails(id);
        }
      } catch (error) {
        if (error.name === "ValidationError") {
          const errors = {};
          error.inner.forEach((err) => {
            errors[err.path] = err.message;
          });
          setFormErrors(errors);
        } else {
          console.error("Error submitting employee details:", error);
          toast.error("Failed to submit employee details. Please try again.");
        }
      }
    },
    [domainFormData, employeeDomainData, id, fetchEmployeeDetails]
  );

  const handleEmpSkillAdd = useCallback(() => {
    resetSkillForm();
    setEmpSkillModel(true);
  }, [resetSkillForm]);

  const handleEmpSkillEdit = useCallback(
    (itemSkill) => {
      const matchedSkillOption = skillsOptList.find(
        (opt) => opt.label === itemSkill.Skill
      );
      setSkillFormData({
        ID: itemSkill.ContactID || "",
        LineNo: itemSkill.LineNo || "",
        SkillID: matchedSkillOption?.value || "",
        SubSkillID: itemSkill.SubSkillID || "",
        Description: itemSkill.SkillDetails || "",
        Ratings: itemSkill.Ratings || "",
        Experience: itemSkill.Experience || "",
        SkillType: itemSkill.SkillType || "",
      });
      if (matchedSkillOption?.value) {
        callAnotherApi(matchedSkillOption.value);
      }
      setEmpSkillModel(true);
    },
    [skillsOptList, callAnotherApi]
  );

  const handleEmpSkillChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
        if (
      (name === "Description") &&
      value.length > 255
    ) {
      setSkillErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 255 Characters allowed for ${name}.`,
      }));
      return;
    }
      setSkillFormData((prevData) => ({ ...prevData, [name]: value }));
      setSkillErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else {
      const { name, value } = e;
        if (
      (name === "Description") &&
      value.length > 255
    ) {
      setSkillErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Max 255 Characters allowed for ${name}.`,
      }));
      return;
    }
      setSkillFormData((prevData) => ({ ...prevData, [name]: value }));
      setSkillErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  }, []);

  const handleEmpSkillSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setSkillSubmitting(true);
      try {
          const maxLineNo =
              employeeSkillData.length > 0
                  ? Math.max(...employeeSkillData.map((item) => item.LineNo || 0))
                  : 0;
          const nextLineNo = maxLineNo + 1;

          const formDataToSubmit = SkillformData.ID
              ? SkillformData
              : { ...SkillformData, LineNo: nextLineNo };

          await skillSchema.validate(formDataToSubmit, { abortEarly: false });
          setSkillErrors({});

          const url = formDataToSubmit.ID
              ? `${API_URL}nest/users/profile/skillSets/empSkillSets/${formDataToSubmit.ID}`
              : `${API_URL}nest/users/profile/skillSets/empSkillSets`;

          const method = formDataToSubmit.ID ? "put" : "post";

          const response = await PostFormServiceCaller(
              url,
              formDataToSubmit,
              method
          );

          if (response.status === 200 || response.status === 201) {
              toast.success(
                  `Skill details ${
                      formDataToSubmit.ID ? "updated" : "added"
                  } successfully!`
              );
              resetSkillForm();
              fetchEmployeeDetails(id);
              setEmpSkillModel(false);
          }
      } catch (error) {
          if (error.inner) {
              const formErrors = {};
              error.inner.forEach((err) => {
                  formErrors[err.path] = err.message;
              });
              setSkillErrors(formErrors);
          } else {
              console.error("Error submitting form:", error);
              toast.error("Failed to submit skill details. Please try again.");
          }
      } finally {
          setSkillSubmitting(false);
      }
    },
    [SkillformData, employeeSkillData, id, fetchEmployeeDetails, resetSkillForm]
);

  const handleAdditionalInfo = useCallback(() => {
    setAddFormData({
      ID: additinalInfoData.ContactID || "",
      PFNo: additinalInfoData.PFNo || "",
      PANNo: additinalInfoData.PANNo || "",
      AadhaarCardNo: additinalInfoData.AadhaarCardNo || "",
      LicenseNo: additinalInfoData.LicenseNo || "",
      PassportNo: additinalInfoData.PassportNo || "",
      PassportEffectiveDate: additinalInfoData.PassportEffectiveDate
        ? moment(additinalInfoData.PassportEffectiveDate).format("DD-MMM-YYYY")
        : "",
      PassportExpiryDate: additinalInfoData.PassportExpiryDate
        ? moment(additinalInfoData.PassportExpiryDate).format("DD-MMM-YYYY")
        : "",
    });
    setEmpAdditionalInfoModel(true);
  }, [additinalInfoData]);

  const handleEmpAddionalInformationChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setAddFormData((prevData) => ({ ...prevData, [name]: value }));
    } else {
      const { name, value } = e;
      setAddFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  }, []);

  const handleAdditionalInfoSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const response = await PostFormServiceCaller(
          `${API_URL}nest/users/profile/empAdditionalInfo/${AddformData.ID}`,
          AddformData,
          "put"
        );

        if (response.status === 200 || response.status === 201) {
          toast.success("Data updated successfully!");
          fetchEmployeeDetails(id);
          setEmpAdditionalInfoModel(false);
        } else {
          toast.error("Failed to submit data.");
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        toast.error("Something went wrong!");
      }
    },
    [AddformData, id, fetchEmployeeDetails]
  );

  const handleOfficilaInfo = useCallback(() => {
    setOtherFormData({
      ID: otherInfoData.ID || "",
      Name: otherInfoData.Name || "",
      MobileNo1: otherInfoData.MobileNo1 || "",
    });
    setEmpOtheradditionalInfoModel(true);
  }, [otherInfoData]);

  const handleEmpOtherInformationChange = useCallback((e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setOtherFormData((prevData) => ({ ...prevData, [name]: value }));
    } else {
      const { name, value } = e;
      setOtherFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  }, []);

  const handleOfficialInfoSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        const response = await PostFormServiceCaller(
          `${API_URL}nest/users/profile/updateOfficialInfo/${otherformData.ID}`,
          otherformData,
          "put"
        );

        if (response.status === 200 || response.status === 201) {
          toast.success("Data updated successfully!");
          fetchEmployeeDetails(id);
          setEmpOtheradditionalInfoModel(false);
        } else {
          toast.error("Failed to submit data.");
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        toast.error("Something went wrong!");
      }
    },
    [otherformData, id, fetchEmployeeDetails]
  );

  const handleProfileImageSubmit = useCallback(
    async (file) => {
      if (!file) return;

      const formData = new FormData();
      formData.append("profileImage", file);

      try {
        const response = await PostFormServiceCaller(
          `${API_URL}nest/user/profile/profilePhoto/${empData.ContactID}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response?.status === 200) {
          toast.success("Uploaded successfully");
          setTimeout(() => {
            fetchEmployeeDetails(id);
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Failed to upload profile photo.");
      }
    },
    [empData.ContactID, id, fetchEmployeeDetails]
  );

  const handleProfilePhotoChange = useCallback(
    async (e) => {
      const file = e.target.files[0];
      if (file) {
        setEmpProfileImage(file);
        await handleProfileImageSubmit(file);
      }
    },
    [handleProfileImageSubmit]
  );

  const renderTooltip = useCallback(
    (text) => <Tooltip id="tooltip">{text}</Tooltip>,
    []
  );

  const handleSelect = useCallback((selectedIndex) => {
    setIndex(selectedIndex);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const heading = isMobile
        ? "Employee Profile"
        : "Employee Profile | Nice Software Solutions Pvt. Ltd.";

      dispatch(updateNavbarHeading(heading));
    };

    // Set initial heading
    handleResize();

    // Update heading when window is resized
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  useEffect(() => {
    fetchEmployeeDetails(id);
  }, [id, fetchEmployeeDetails]);

  useEffect(() => {
    fetchDegreeList();
  }, [fetchDegreeList]);

  useEffect(() => {
    const groups = [];
    for (let i = 0; i < empAwards.length; i += 3) {
      groups.push(empAwards.slice(i, i + 3));
    }
    setGroupedAwards(groups);
  }, [empAwards]);

  useEffect(() => {
    if (groupedAwards.length > 1) {
      const interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % groupedAwards.length);
      }, 15000);
      return () => clearInterval(interval);
    }
  }, [groupedAwards.length]);

  if (pageLoading) {
    return (
      <p className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </p>
    );
  }

  return (
    <div className="container-fluid" id="dashboard_section">
      <div className="row mt-2">
        <div className="col-md-12">
          <ProfileEmpCard
            empData={empData}
            employeeCanEdit={employeeCanEdit}
            groupedAwards={groupedAwards}
            onProfilePhotoChange={handleProfilePhotoChange}
          />
        </div>
      </div>
      <div className="row g-3">
        <div className="col-xl-8">
          <ProjectComponent
            currentProjectsData={currentProjectsData}
            previousProjectsData={previousProjectsData}
          />
          <div className="p-0 mt-2 forum-tab">
            <ul className="nav nav-tabs overflow multi-tabs" role="tablist">
              {shouldRenderComponent && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link forum-tab-btn ${
                      defaultActiveTab === "official" ? "active" : ""
                    }`}
                    id="official-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#official"
                    type="button"
                    role="tab"
                    aria-controls="official"
                    aria-selected={defaultActiveTab === "official"}
                  >
                    <strong>Address and Bank</strong>
                  </button>
                </li>
              )}
              <li
                className="nav-item"
                role="presentation"
                style={{ marginLeft: "2px" }}
              >
                <button
                  className="nav-link forum-tab-btn"
                  id="emp-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#emp"
                  type="button"
                  role="tab"
                  aria-controls="emp"
                  aria-selected="false"
                >
                  <strong>Previous Employment</strong>
                </button>
              </li>
              <li
                className="nav-item"
                role="presentation"
                style={{ marginLeft: "3px" }}
              >
                <button
                  className="nav-link forum-tab-btn"
                  id="empSkill-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#empSkill"
                  type="button"
                  role="tab"
                  aria-controls="empSkill"
                  aria-selected="false"
                >
                  <strong>Employment Skill</strong>
                </button>
              </li>
            </ul>
          </div>
          <div className="emp_info_sect">
            <div className="tab-content" id="myTabContent">
              {shouldRenderComponent && (
                <div
                  className={`tab-pane fade ${
                    defaultActiveTab === "official" ? "show active" : ""
                  }`}
                  id="official"
                  role="tabpanel"
                  aria-labelledby="official-tab"
                >
                  <div className="container-fluid p-0 mt-2">
                    <EmpBankAddressComponent empData={empData} />
                  </div>
                </div>
              )}
              <div
                className={`tab-pane fade ${
                  defaultActiveTab === "emp" ? "show active" : ""
                }`}
                id="emp"
                role="tabpanel"
                aria-labelledby="emp-tab"
              >
                <div className="text-end mt-1">
                  <OverlayTrigger
                    placement="top"
                    overlay={renderTooltip(
                      Number(employeeCanEdit) === 1 ? "Add" : "Editing disabled"
                    )}
                  >
                    <button
                      className="custom-btn-sm mb-2"
                      onClick={
                        Number(employeeCanEdit) === 1
                          ? handleEmpHistoryAdd
                          : undefined
                      }
                      style={{
                        cursor:
                          Number(employeeCanEdit) === 1
                            ? "pointer"
                            : "not-allowed",
                        opacity: Number(employeeCanEdit) === 1 ? 1 : 0.5,
                      }}
                      disabled={Number(employeeCanEdit) !== 1}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </OverlayTrigger>
                </div>
                <PreviousEmpComponent
                  data={employeeHistoryData}
                  canEdit={Number(employeeCanEdit) === 1}
                  onEdit={handleEmpHistoryEdit}
                  onDelete={handleEmpHistoryDelete}
                />
              </div>
              <div
                className="tab-pane fade"
                id="empSkill"
                role="tabpanel"
                aria-labelledby="empSkill"
              >
                <div className="mt-2">
                  <div className="container-fluid p-0">
                    <div className="p-0 forum-tab">
                      <ul
                        className="nav nav-tabs overflow multi-tabs"
                        role="tablist"
                      >
                        <li className="nav-item-child" role="presentation">
                          <button
                            className="nav-link forum-child-tab-btn active"
                            id="Academic-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#Academic"
                            type="button"
                            role="tab"
                            aria-controls="Academic"
                            aria-selected="true"
                          >
                            <strong>Academic</strong>
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          role="presentation"
                          style={{ marginLeft: "2px" }}
                        >
                          <button
                            className="nav-link forum-child-tab-btn"
                            id="Skill-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#Skill"
                            type="button"
                            role="tab"
                            aria-controls="Skill"
                            aria-selected="false"
                          >
                            <strong>Skill Sets</strong>
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          role="presentation"
                          style={{ marginLeft: "3px" }}
                        >
                          <button
                            className="nav-link forum-child-tab-btn"
                            id="Training-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#Training"
                            type="button"
                            role="tab"
                            aria-controls="Training"
                            aria-selected="false"
                          >
                            <strong>Certifications/Training</strong>
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          role="presentation"
                          style={{ marginLeft: "3px" }}
                        >
                          <button
                            className="nav-link forum-child-tab-btn"
                            id="domain-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#domain"
                            type="button"
                            role="tab"
                            aria-controls="domain"
                            aria-selected="false"
                          >
                            <strong>Domain</strong>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div className="emp-forum_sect">
                      <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="Academic"
                          role="tabpanel"
                          aria-labelledby="Academic-tab"
                        >
                          <div className="text-end mb-2">
                            <OverlayTrigger
                              placement="top"
                              overlay={renderTooltip("Add Academic")}
                            >
                              <button
                                className="custom-btn-sm"
                                onClick={
                                  Number(employeeCanEdit) === 1
                                    ? handleEmpAcademicAdd
                                    : undefined
                                }
                                style={{
                                  cursor:
                                    Number(employeeCanEdit) === 1
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity:
                                    Number(employeeCanEdit) === 1 ? 1 : 0.5,
                                }}
                                disabled={Number(employeeCanEdit) !== 1}
                              >
                                <i className="bi bi-plus"></i>
                              </button>
                            </OverlayTrigger>
                          </div>
                          <EmpAcademicTableComponent
                            data={employeeAcademicData}
                            canEdit={Number(employeeCanEdit) === 1}
                            onEdit={handleEmpAcademicEdit}
                          />
                        </div>
                        <div
                          className="tab-pane fade"
                          id="Skill"
                          role="tabpanel"
                          aria-labelledby="Skill-tab"
                        >
                          <div className="text-end">
                            <OverlayTrigger
                              placement="right"
                              overlay={renderTooltip("Add Skill")}
                            >
                              <button
                                className="custom-btn-sm mb-2"
                                onClick={
                                  Number(employeeCanEdit) === 1
                                    ? handleEmpSkillAdd
                                    : undefined
                                }
                                style={{
                                  cursor:
                                    Number(employeeCanEdit) === 1
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity:
                                    Number(employeeCanEdit) === 1 ? 1 : 0.5,
                                }}
                                disabled={Number(employeeCanEdit) !== 1}
                              >
                                <i className="bi bi-plus"></i>
                              </button>
                            </OverlayTrigger>
                          </div>
                          <EmpSkillTableComponent
                            data={employeeSkillData}
                            canEdit={Number(employeeCanEdit) === 1}
                            onEdit={handleEmpSkillEdit}
                          />
                        </div>
                        <div
                          className="tab-pane fade"
                          id="Training"
                          role="tabpanel"
                          aria-labelledby="Training-tab"
                        >
                          <div className="text-end mb-2">
                            <OverlayTrigger
                              placement="right"
                              overlay={renderTooltip("Add Training")}
                            >
                              <button
                                className="custom-btn-sm"
                                onClick={
                                  Number(employeeCanEdit) === 1
                                    ? handleEmpTraining
                                    : undefined
                                }
                                style={{
                                  cursor:
                                    Number(employeeCanEdit) === 1
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity:
                                    Number(employeeCanEdit) === 1 ? 1 : 0.5,
                                }}
                                disabled={Number(employeeCanEdit) !== 1}
                              >
                                <i className="bi bi-plus"></i>
                              </button>
                            </OverlayTrigger>
                          </div>
                          <EmpCertificationTable
                            data={employeeCertificationData}
                            canEdit={Number(employeeCanEdit) === 1}
                            onEdit={handleEmpTrainingEdit}
                          />
                        </div>
                        <div
                          className="tab-pane fade"
                          id="domain"
                          role="tabpanel"
                          aria-labelledby="domain-tab"
                        >
                          <div className="text-end mb-2">
                            <OverlayTrigger
                              placement="right"
                              overlay={renderTooltip("Add Domain")}
                            >
                              <button
                                className="custom-btn-sm"
                                onClick={
                                  Number(employeeCanEdit) === 1
                                    ? handleEmpDomainAdd
                                    : undefined
                                }
                                style={{
                                  cursor:
                                    Number(employeeCanEdit) === 1
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity:
                                    Number(employeeCanEdit) === 1 ? 1 : 0.5,
                                }}
                                disabled={Number(employeeCanEdit) !== 1}
                              >
                                <i className="bi bi-plus"></i>
                              </button>
                            </OverlayTrigger>
                          </div>
                          <EmpDomainComponent
                            data={employeeDomainData}
                            canEdit={Number(employeeCanEdit) === 1}
                            onEdit={handleEmpDomainEdit}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <p></p>
          </div>
        </div>
        <div className="col-xl-4 Profile-Margin">
          <KnowledgeBaseComponent
            items={knowledgeForum}
            noItemsMessage="No Knowledge Base added"
            id={id}
            DefaultContactID={DefaultContactID}
          />
          <OfficialInformationComponent
            data={empData}
            fields={[
              { key: "ContactName", label: "Contact Name" },
              { key: "MobileNo1", label: "Contact Phone" },
            ]}
            onEdit={handleOfficilaInfo}
          />
          {shouldRenderComponent && (
            <AdditionalInfoComponent
              employeeCanEdit={employeeCanEdit}
              additionalInfoData={additinalInfoData}
              onEditClick={() => setEmpAdditionalInfoModel(true)}
            />
          )}
        </div>
      </div>
      {/* model popup employee Histroy */}
      {empHistoryModel && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  {formData.ID
                    ? "Edit Employment Details"
                    : "Add Employment Details"}
                </p>

                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    // onClick={() => setEmpHistoryModel(false)}
                    onClick={() => {
                      setEmpHistoryModel(false);
                      resetHistoryForm(); // Reset when closing
                    }}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleEmpHistorySubmit}>
                  <div className="row">
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="CompanyName" class="form-label">
                          Company<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="CompanyName"
                          aria-describedby="CompanyName"
                          name="CompanyName"
                          placeholder="Company Name"
                          value={formData.CompanyName}
                          onChange={handleEmpHistoryChange}
                        />
                        {formHistoryErrors.CompanyName && (
                          <p className="error">
                            {formHistoryErrors.CompanyName}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Position" class="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Position"
                          aria-describedby="Position"
                          name="Position"
                          placeholder="Designation"
                          value={formData.Position}
                          onChange={handleEmpHistoryChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          Location
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="Location"
                          aria-describedby="Location"
                          name="Location"
                          placeholder="Location"
                          value={formData.Location}
                          onChange={handleEmpHistoryChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          From Date<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpHistoryChange}
                          value={formData.FromDate}
                          name="FromDate"
                          id="FromDate"
                          className="form-control"
                          placeholderText="From Date"
                        />
                        {formHistoryErrors.FromDate && (
                          <p className="error">{formHistoryErrors.FromDate}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          To Date<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpHistoryChange}
                          value={formData.ToDate}
                          name="ToDate"
                          id="ToDate"
                          className="form-control"
                          placeholderText="To Date"
                        />
                        {formHistoryErrors.ToDate && (
                          <p className="error">{formHistoryErrors.ToDate}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          Address
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="OrganizationAddress"
                          aria-describedby="OrganizationAddress"
                          name="OrganizationAddress"
                          placeholder="Organization Address"
                          value={formData.OrganizationAddress}
                          onChange={handleEmpHistoryChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          Job Brief
                        </label>
                        <textarea
                          type="text"
                          class="form-control"
                          id="JobDescription"
                          aria-describedby="JobDescription"
                          name="JobDescription"
                          placeholder="Job Brief"
                          value={formData.JobDescription}
                          onChange={handleEmpHistoryChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      // onClick={() => setEmpHistoryModel(false)}
                      onClick={(e) => {
                        e.preventDefault(); // Prevent form submit
                        setEmpHistoryModel(false);
                        resetHistoryForm(); // Reset when closing
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* model popup Employee Acedemic */}
      {empAcedemicModel && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  {acedemicFormData.ID
                    ? "Edit Academic Details"
                    : "Add Academic Details"}
                </p>
                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    onClick={() => {
                      setEmpAcedemicModel(false);
                      resetAcedemicForm();
                    }}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleEmpAcademicSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="University" class="form-label">
                          University<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="University"
                          aria-describedby="University"
                          name="University"
                          placeholder="University"
                          value={acedemicFormData.University}
                          onChange={handleEmpAcademicChange}
                        />
                        {acedemicErrors.University && (
                          <p className="error">{acedemicErrors.University}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Institute" class="form-label">
                          Institute<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Institute"
                          aria-describedby="Institute"
                          name="Institute"
                          placeholder="Institute"
                          value={acedemicFormData.Institute}
                          onChange={handleEmpAcademicChange}
                        />
                        {acedemicErrors.Institute && (
                          <p className="error">{acedemicErrors.Institute}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Degree" class="form-label">
                          Degree<span className="required">*</span>
                        </label>
                        <Select
                          options={[
                            { value: "", label: "Select" },
                            ...degreeOptList,
                          ]}
                          value={degreeOptList.find(
                            (option) =>
                              option.value === acedemicFormData?.Degree_152
                          )}
                          name="Degree_152"
                          onChange={(selectedOption) =>
                            handleEmpAcademicChange({
                              name: "Degree_152",
                              value: selectedOption?.value || "",
                            })
                          }
                        />
                        {acedemicErrors.Degree_152 && (
                          <p className="error">{acedemicErrors.Degree_152}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="DegreeInfo" class="form-label">
                          Degree Info
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="DegreeInfo"
                          aria-describedby="DegreeInfo"
                          name="DegreeInfo"
                          placeholder="Degree Info"
                          value={acedemicFormData.DegreeInfo}
                          onChange={handleEmpAcademicChange}
                        />
                        {acedemicErrors.DegreeInfo && (
                        <p className="error">{acedemicErrors.DegreeInfo}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="FromDate" class="form-label">
                          FromDate<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpAcademicChange}
                          value={acedemicFormData.FromDate}
                          name="FromDate"
                          id="FromDate"
                          className="form-control"
                          placeholderText="From Date"
                        />
                        {acedemicErrors.FromDate && (
                          <p className="error">{acedemicErrors.FromDate}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Location" class="form-label">
                          To Date<span className="required">*</span>
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpAcademicChange}
                          value={acedemicFormData.ToDate}
                          name="ToDate"
                          id="ToDate"
                          className="form-control"
                          placeholderText="To Date"
                        />
                        {acedemicErrors.ToDate && (
                          <p className="error">{acedemicErrors.ToDate}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Description" class="form-label">
                          Description
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="Description"
                          aria-describedby="Description"
                          name="Description"
                          placeholder="Description"
                          value={acedemicFormData.Description}
                          onChange={handleEmpAcademicChange}
                        />
                        {acedemicErrors.Description && (
                        <p className="error">{acedemicErrors.Description}</p>
                       )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Grade" class="form-label">
                          Grade
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="Grade"
                          aria-describedby="Grade"
                          name="Grade"
                          placeholder="Grade"
                          value={acedemicFormData.Grade}
                          onChange={handleEmpAcademicChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent form submit
                        setEmpAcedemicModel(false);
                        resetAcedemicForm(); // Reset when closing
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* model popup Employee Training/ Certifications */}
      {empTrainingModel && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  {trainingFormData.ID
                    ? "Edit Certification(s) / Training"
                    : "Add Certification(s) / Training"}
                </p>

                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    onClick={() => {
                      SetEmpTrainingModel(false);
                      resetEmpTrainingForm(); // Reset when closing
                    }}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleEmpTrainingSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Title" class="form-label">
                          Title<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Title"
                          aria-describedby="Title"
                          name="Title"
                          placeholder="Title"
                          value={trainingFormData.Title}
                          onChange={handleEmpTrainingChange}
                        />
                        {trainingErrors.Title && (
                          <p className="error">{trainingErrors.Title}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Description" class="form-label">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Description"
                          aria-describedby="Description"
                          name="Description"
                          placeholder="Description"
                          value={trainingFormData.Description}
                          onChange={handleEmpTrainingChange}
                        />
                        {trainingErrors.Description && (
                          <p className="error">{trainingErrors.Description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Degree" class="form-label">
                          Valid From
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpTrainingChange}
                          value={trainingFormData.ValidFrom}
                          name="ValidFrom"
                          id="ValidFrom"
                          className="form-control"
                          placeholderText="Valid From"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="ValidTill" class="form-label">
                          Valid Till
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpTrainingChange}
                          value={trainingFormData.ValidTill}
                          name="ValidTill"
                          id="ValidTill"
                          className="form-control"
                          placeholderText="Valid Till"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent form submission
                        SetEmpTrainingModel(false);
                        resetEmpTrainingForm(); // Reset when closing
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* model popup Employee Domain */}
      {empDomainModel && (
        <div
          className="modal"
          tabIndex="-1"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  {domainFormData.ID ? "Edit Domain Set" : "Add Domain Set"}
                </p>
                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    // onClick={() => setEmpDomainModel(false)}
                    onClick={() => {
                      setEmpDomainModel(false);
                      resetDomainForm(); // Reset when closing
                    }}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleEmpDomainSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Title" class="form-label">
                          Domain<span className="required">*</span>
                        </label>
                        <Select
                          options={[
                            { value: "", label: "Select" },
                            ...domainOptList,
                          ]}
                          value={domainOptList.find(
                            (option) => option.value === domainFormData.DomainID // Match by DomainID
                          )}
                          name="DomainID"
                          onChange={(selectedOption) =>
                            handleEmpDomainChange({
                              name: "DomainID",
                              value: selectedOption?.value || "",
                            })
                          }
                        />
                        {formErrors.DomainID && (
                          <p className="error">{formErrors.DomainID}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Experience" class="form-label">
                          Experience
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Experience"
                          aria-describedby="Experience"
                          name="Experience"
                          placeholder="Experience"
                          value={domainFormData.Experience}
                          onChange={handleEmpDomainChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Degree" class="form-label">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Description"
                          aria-describedby="Description"
                          name="Description"
                          placeholder="Description"
                          value={domainFormData.Description}
                          onChange={handleEmpDomainChange}
                        />
                         {formErrors.Description && (
                          <p className="error">{formErrors.Description}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="ClientName" class="form-label">
                          Client Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="ClientName"
                          aria-describedby="ClientName"
                          name="ClientName"
                          placeholder="ClientName"
                          value={domainFormData.ClientName}
                          onChange={handleEmpDomainChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      // onClick={() => setEmpDomainModel(false)}
                      onClick={(e) => {
                        e.preventDefault(); // Prevent form submit
                        setEmpDomainModel(false);
                        resetDomainForm(); // Reset when closing
                      }}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* model popup Employee Skill */}
      {empskillModel && (
          <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                  display: "block",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
          >
              <div
                  className="modal-dialog modal-md modal-dialog-centered"
                  role="document"
              >
                  <div className="modal-content">
                      <div
                          className="modal-header"
                          style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              borderBottom: "1px solid #f0f0f0",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "8px 8px 0 0",
                          }}
                      >
                          <p
                              style={{
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  color: "#27568B",
                                  margin: "0",
                              }}
                          >
                              {SkillformData.ID ? "Edit Skill Set" : "Add Skill Set"}
                          </p>
                          <span className="me-2">
                              <i
                                  className="bi bi-x-lg"
                                  onClick={() => {
                                      setEmpSkillModel(false);
                                      resetSkillForm();
                                  }}
                              ></i>
                          </span>
                      </div>
                      <div className="modal-body p-2">
                          <form onSubmit={handleEmpSkillSubmit}>
                              <div className="row">
                                  <div className="col-md-4">
                                      <div class="mb-3">
                                          <label for="Title" class="form-label">
                                              Skill<span className="required">*</span>
                                          </label>
                                          <Select
                                              options={[
                                                  { value: "", label: "Select" },
                                                  ...skillsOptList,
                                              ]}
                                              value={skillsOptList.find(
                                                  (option) => option.value === SkillformData?.SkillID
                                              )}
                                              name="SkillID"
                                              onChange={(selectedOption) => {
                                                  const value = selectedOption?.value || "";
                                                  handleEmpSkillChange({
                                                      name: "SkillID",
                                                      value,
                                                  });
                                                  if (value) {
                                                      callAnotherApi(value);
                                                  }
                                              }}
                                          />
                                          {skillErrors.SkillID && (
                                              <p className="error">{skillErrors.SkillID}</p>
                                          )}
                                      </div>
                                  </div>
                                  <div className="col-md-4">
                                      <div class="mb-3">
                                          <label for="Experience" class="form-label">
                                              Sub Skill
                                          </label>
                                          <Select
                                              options={[
                                                  { value: "", label: "Select" },
                                                  ...subSkillOptList,
                                              ]}
                                              value={
                                                  subSkillOptList.find(
                                                      (option) =>
                                                          String(option.value) ===
                                                          String(SkillformData?.SubSkillID)
                                                  ) || null
                                              }
                                              name="SubSkillID"
                                              onChange={(selectedOption) =>
                                                  handleEmpSkillChange({
                                                      name: "SubSkillID",
                                                      value: selectedOption?.value || "",
                                                  })
                                              }
                                          />
                                      </div>
                                  </div>
                                  <div className="col-md-4">
                                      <div class="mb-3">
                                          <label for="Experience" class="form-label">
                                              Experience
                                          </label>
                                          <Select
                                              options={[
                                                  { value: "", label: "Select" },
                                                  ...experienceOptList,
                                              ]}
                                              value={experienceOptList.find(
                                                  (option) =>
                                                      option.label === SkillformData?.Experience
                                              )}
                                              name="Experience"
                                              onChange={(selectedOption) =>
                                                  handleEmpSkillChange({
                                                      name: "Experience",
                                                      value: selectedOption?.value || "",
                                                  })
                                              }
                                          />
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-md-12">
                                      <div class="mb-3">
                                          <label for="Degree" class="form-label">
                                              Description
                                          </label>
                                          <textarea
                                              type="text"
                                              className="form-control"
                                              id="Description"
                                              aria-describedby="Description"
                                              name="Description"
                                              placeholder="Description"
                                              value={SkillformData.Description}
                                              onChange={handleEmpSkillChange}
                                          ></textarea>
                                          {skillErrors.Description && (
                                              <p className="error">{skillErrors.Description}</p>
                                          )}
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-md-6">
                                      <div>
                                          <label for="Degree" class="form-label">
                                              Expertise out of 5
                                          </label>
                                          <div>
                                              {[1, 2, 3, 4, 5].map((star) => (
                                                  <FaStar
                                                      key={star}
                                                      size={20}
                                                      onClick={() =>
                                                          handleEmpSkillChange({
                                                              name: "Ratings",
                                                              value: star,
                                                          })
                                                      }
                                                      style={{ cursor: "pointer", marginRight: 5 }}
                                                      color={
                                                          star <= (SkillformData.Ratings || 0)
                                                              ? "orange"
                                                              : "gray"
                                                      }
                                                  />
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div>
                                          <label for="SkillType" class="form-label">
                                              Skill Type<span className="required">*</span>
                                          </label>
                                          <div className="d-flex">
                                              <div className="form-check me-2" key="Primary">
                                                  <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      name="SkillType"
                                                      id="primary_radio"
                                                      value="1"
                                                      checked={
                                                          SkillformData.SkillType?.toString() === "1"
                                                      }
                                                      onChange={handleEmpSkillChange}
                                                  />
                                                  <label
                                                      className="form-check-label"
                                                      htmlFor="primary_radio"
                                                  >
                                                      Primary
                                                  </label>
                                              </div>
                                              <div className="form-check me-2" key="Secondary">
                                                  <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      name="SkillType"
                                                      id="secondary_radio"
                                                      value="2"
                                                      checked={
                                                          SkillformData.SkillType?.toString() === "2"
                                                      }
                                                      onChange={handleEmpSkillChange}
                                                  />
                                                  <label
                                                      className="form-check-label"
                                                      htmlFor="secondary_radio"
                                                  >
                                                      Secondary
                                                  </label>
                                              </div>
                                          </div>
                                          {/* Add error message for SkillType */}
                                          {skillErrors.SkillType && (
                                              <p className="error">{skillErrors.SkillType}</p>
                                          )}
                                      </div>
                                  </div>
                              </div>

                              <div className="text-end mt-2">
                                <button
                                    className="cancel-btn me-2"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setEmpSkillModel(false);
                                        resetSkillForm();
                                    }}
                                    disabled={skillSubmitting}
                                >
                                    Cancel
                                </button>
                                <button 
                                  type="submit" 
                                  className="custom-btn"
                                  disabled={skillSubmitting}
                                  style={{ 
                                      minWidth: '90px',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '6px',
                                      opacity: skillSubmitting ? 0.8 : 1,
                                      cursor: skillSubmitting ? 'not-allowed' : 'pointer'
                                  }}
                              >
                                  {skillSubmitting ? (
                                      <>
                                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '14px', height: '14px' }}></span>
                                          <span style={{ fontSize: '13px' }}>Submitting...</span>
                                      </>
                                  ) : (
                                      "Submit"
                                  )}
                              </button>
                            </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      )}

      {/* edit Model other official Information */}
      {empOtheradditionalInfoModel && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  Edit My Other Additional Information
                </p>
                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    onClick={() => setEmpOtheradditionalInfoModel(false)}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleOfficialInfoSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="Name" class="form-label">
                          Contact Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Name"
                          aria-describedby="Name"
                          name="Name"
                          placeholder="Contact Name"
                          value={otherformData.Name}
                          onChange={handleEmpOtherInformationChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="MobileNo1" class="form-label">
                          Contact Phone
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="MobileNo1"
                          aria-describedby="MobileNo1"
                          name="MobileNo1"
                          placeholder="Contact Phone"
                          value={otherformData.MobileNo1}
                          onChange={handleEmpOtherInformationChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <button
                      className="cancel-btn me-2"
                      onClick={() => setEmpOtheradditionalInfoModel(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* edit Model popup Additional Information */}
      {empadditionalInfoModel && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  Edit My Additional Information
                </p>
                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    onClick={() => setEmpAdditionalInfoModel(false)}
                  ></i>
                </span>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAdditionalInfoSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="PassportNo" class="form-label">
                          Passport Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="PassportNo"
                          aria-describedby="PassportNo"
                          name="PassportNo"
                          placeholder="PassportNo"
                          value={AddformData.PassportNo}
                          onChange={handleEmpAddionalInformationChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="PassportEffectiveDate" class="form-label">
                          Passport Date Of Issue
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpAddionalInformationChange}
                          value={AddformData.PassportEffectiveDate}
                          name="PassportEffectiveDate"
                          id="PassportEffectiveDate"
                          className="form-control"
                          placeholderText="Effective Date"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="PassportExpiryDate" class="form-label">
                          Passport Expiry Date
                        </label>
                        <CustomDatePicker
                          handleChange={handleEmpAddionalInformationChange}
                          value={AddformData.PassportExpiryDate}
                          name="PassportExpiryDate"
                          id="PassportExpiryDate"
                          className="form-control"
                          placeholderText="Expiry Date"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="PANNo" class="form-label">
                          PAN Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="PANNo"
                          aria-describedby="PANNo"
                          name="PANNo"
                          placeholder="PAN Number"
                          value={AddformData.PANNo}
                          onChange={handleEmpAddionalInformationChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="LicenseNo" class="form-label">
                          License No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="LicenseNo"
                          aria-describedby="LicenseNo"
                          name="LicenseNo"
                          placeholder="License No"
                          value={AddformData.LicenseNo}
                          onChange={handleEmpAddionalInformationChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="AadhaarCardNo" class="form-label">
                          Aadhar Card No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="AadhaarCardNo"
                          aria-describedby="AadhaarCardNo"
                          name="AadhaarCardNo"
                          placeholder="Aadhar Card No"
                          value={AddformData.AadhaarCardNo}
                          onChange={handleEmpAddionalInformationChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div class="mb-3">
                        <label for="PFNo" class="form-label">
                          PF Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="PFNo"
                          aria-describedby="PFNo"
                          name="PFNo"
                          placeholder="PF Number"
                          value={AddformData.PFNo}
                          onChange={handleEmpAddionalInformationChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="text-end">
                        <button
                          className="me-2 cancel-btn"
                          onClick={() => setEmpAdditionalInfoModel(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(EmployeeProfile);
